import React from 'react';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import SwipableList from '../swiper/SwipableList';


const StyledAccordion = styled(Accordion)`
background-color: ${((props) => props.theme.palette.primary.background)};
`;

function CustomAccordion(props) {

  return (
    <StyledAccordion defaultExpanded >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panelCapability-content"
        id="panelCapability-header"
      >
        <Grid container spacing={1} justifyContent="center"
          alignItems="center">

          <Grid item lg={12} md={12} xs={12}>
            <Typography sx={{ color: 'inherit' }} align="center">
              {props.label}
            </Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails >
        <SwipableList {...props} />

      </AccordionDetails>
    </StyledAccordion>
  );
}

export default CustomAccordion;
